<template>
	<div>
		<p v-if="!properties.length" class="c-cp-total">{{$t("recents.title")}} : {{properties.length }}</p>
	  	<ul class="c-mini-cards">
	    	<property 
	    		v-on:favRemove="fav_remove"
	    		v-on:favAdd="fav_add"
	    		v-for="property in properties" 
	    		:key="property.reference" 
	    		v-bind="property" 
	    		/>
	  	</ul>
  </div>
</template>

<script>
	import LFPortal from '../portal/portal.js'
	import Property from './property.vue';
	export default {
		components: {Property},		
	  name: 'recents',
	  props: ['properties'],
	  data () {return {};},
		methods: {
			fav_remove: function(reference){
				LFPortal.Favs.remove(reference);
			},
			fav_add: function(reference){
				LFPortal.Favs.add(reference);
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/recents.vue